
import React, { useState, useEffect } from 'react';
import { MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

interface FloatingCTAProps {
  industry?: string;
}

const FloatingCTA: React.FC<FloatingCTAProps> = ({ industry }) => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();
  
  useEffect(() => {
    // Show the floating CTA after scrolling a bit
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const handleClick = () => {
    // Get the correct path based on the language
    const contactPath = `/${currentLanguage}/${
      currentLanguage === 'de' ? 'kontakt' : 
      currentLanguage === 'it' ? 'contatto' : 'contact'
    }`;
    
    // Navigate to the contact page
    navigate(contactPath);
  };
  
  if (!isVisible) return null;
  
  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Floating button */}
      <button
        onClick={handleClick}
        className="w-14 h-14 rounded-full bg-gradient-to-br from-purple-700 to-purple-900 text-white flex items-center justify-center shadow-lg shadow-purple-900/30 hover:shadow-purple-900/50 transition-all duration-300 relative group"
        aria-label="Kontakt aufnehmen"
      >
        <MessageSquare className="w-6 h-6" />
        <span className="absolute top-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-[#0A0A0A] animate-pulse"></span>
        
        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full bg-purple-600 opacity-70 group-hover:opacity-0 animate-ping"></span>
      </button>
    </div>
  );
};

export default FloatingCTA;
